import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-image-view',
  templateUrl: 'image-view.component.html',
  standalone: false,
})
export class ImageViewComponent {
  @Input() src: string = '';
}
